import { FileCheck } from "lucide-react";

import { BarChartCard } from "./BarChartCard";
import { formatCount } from "./chartPalette";
import { DonutChartCard } from "./DonutChartCard";
import { ChartsGrid, InsightsPanel, StatsRow } from "./InsightsLayout";
import { StatCard } from "./StatCard";
import { TrendChartCard } from "./TrendChartCard";

export const AuditLogInsights = ({ insights, isLoading }) => {
  return (
    <InsightsPanel>
      <StatsRow>
        <StatCard label="Total Events" icon={FileCheck} isLoading={isLoading}
          value={formatCount(insights?.totalEvents)} />
      </StatsRow>
      <ChartsGrid>
        <BarChartCard title="By Staff Member" data={insights?.byStaff} isLoading={isLoading} />
        <DonutChartCard title="By Access Reason" data={insights?.byReason} isLoading={isLoading} />
        <TrendChartCard title="Access Events Over Time" data={insights?.trendByDay} isLoading={isLoading} />
      </ChartsGrid>
    </InsightsPanel>
  );
};
